export default {
    getHomeAccordions: state => state.homeAccordions,
    getLoadingStatus: state => state.loading,
    getAccordionContent: state => accordion => {
        return state[accordion]
    },
    getLawlexRecentSearches: state => state.lawlexRecentSearches,
    getLawlexNewsfeeds: state => state.lawlexRegulatoryNewsfeeds,
    getEurlexSavedSearches: state => state.eurlexSavedSearches,
    getLawlexLoadingStatus: state => state.getLawlexLoadingStatus,
}